import React from 'react';
import { classNames } from '../../Services/helpers';

const Badge = ({title, theme, className}) => {

    const themes = {
        'secondary': 'bg-gray-600/10 text-gray-600 fill-gray-600 ring-gray-600',
        'danger': 'bg-red-600/10 text-red-600 fill-red-600 ring-red-600',
        'warning': 'bg-orange-600/10 text-orange-600 fill-orange-600 ring-orange-600',
        'info': 'bg-blue605/100 text-blue-600 fill-blue-600 ring-blue-600',
        'success': 'bg-green-600/10 text-green-600 fill-green-600 ring-green-600',
        'brand': 'bg-brand/10 text-brand fill-brand ring-brand',
    }

    const classes = classNames(
        'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset shrink',
        theme && (themes[theme] ?? themes['secondary']),
        className,
    );

    return <span className={classes}>
        {title}
    </span>
}

export default Badge;
